module.exports = __webpack_public_path__ + "static/media/community-builder-1.22f0bdb6.png";